import {
    Box,
    Button,
    Flex,
    Heading,
    Radio,
    RadioGroup,
    Spinner,
    Stack
} from "@chakra-ui/react";
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Select from "react-select";
import { CustomerRegisterForm } from "../../components/Common/Forms/CustomerRegister";
import { PantSizeForm } from "../../components/Common/Forms/PantSizeForm";
import Notification from "../../components/Common/Notification/index";
import BasicLayout from "../../components/Layouts/BasicLayout";
import {
    addCustomer,
    getCustomers,
    updateCustomer
} from "../../store/actions/customer/customer.action";
import {
    addPant, getSinglePant,
    updatePant
} from "../../store/actions/pant/pant.action";
import { getPantCategories } from "../../store/actions/pantcategory/pantcategory.action";
import { getPantOptions } from "../../store/actions/pantoptions/pantoption.action";
import {
    getSinglePantOrder, updatePantOrder
} from "../../store/actions/pantOrder/pantOrder.action";

const Index = () => {
    const { id } = useParams();
    const dispatch = useDispatch();

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [categoryId, setCategoryId] = useState("");
    const [optionIds, setOptionIds] = useState([]);
    const [customerStatus, setCustomerStatus] = useState("1");
    const [selectedCustomer, setSelectedCustomer] = useState([]);

    const pantcategories = useSelector(
        (state) => state.pantcategory.pantcategories
    );
    const pantoptions = useSelector((state) => state.pantoption.pantoptions);
    const customers = useSelector((state) => state.customer.customers);
    const order = useSelector((state) => state.pantorder.pantorder);
    const pant = useSelector((state) => state.pant.pant);

    useEffect(() => {
        if (id) {
            dispatch(getSinglePantOrder(id))
                .then((resp) => resp)
                .catch((err) => {
                    return Notification("", "कृपया पुहा प्रयत्न करा.", "error");
                });
        }
    }, [dispatch, id]);

    useEffect(() => {
        dispatch(getPantCategories());
        dispatch(getPantOptions());
        dispatch(getCustomers());
    }, [dispatch]);

    useEffect(() => {
        setLoading(true)
        if (order) {
            if (order.customer) {
                if (pant) {
                    if (order?.pantcategory) {
                        setCategoryId({
                            label: order?.pantcategory?.category,
                            value: order?.pantcategory?.id,
                        });
                    }
                    if (order?.pantoptions) {
                        let options = order.pantoptions.map((data) => {
                            let temp = {
                                label: data.option,
                                value: data.id,
                            };
                            return temp;
                        });
                        setOptionIds(options);
                    }
                    let data = {
                        ...order.customer,
                        pantData: pant,
                    };
                    setSelectedCustomer([data]);
                }
            }
        }
        setLoading(false)
    }, [dispatch, pant, order]);

    useEffect(() => {
        if (order?.customer?.pant) {
            dispatch(getSinglePant(order.customer.pant));
        }
    }, [order, dispatch]);

    useEffect(() => {
        if (customerStatus === "2") {
            setSelectedCustomer([]);
        }
    }, [customerStatus]);

    const defaultValues = {
        customername:
            selectedCustomer.length === 0 ? "" : selectedCustomer[0].name || "",
        phonenumber:
            selectedCustomer.length === 0
                ? ""
                : selectedCustomer[0].phonenumber || "",
        address:
            selectedCustomer.length === 0 ? "" : selectedCustomer[0].address || "",
        pantSizeId:
            selectedCustomer.length === 0
                ? ""
                : selectedCustomer[0].pantData?.length !== 0
                    ? selectedCustomer[0].pantData?.id || ""
                    : "",
        seat:
            selectedCustomer.length === 0
                ? ""
                : selectedCustomer[0].pantData?.length !== 0
                    ? selectedCustomer[0].pantData?.seat || ""
                    : "",
        gudga:
            selectedCustomer.length === 0
                ? ""
                : selectedCustomer[0].pantData?.length !== 0
                    ? selectedCustomer[0].pantData?.gudga || ""
                    : "",
        height:
            selectedCustomer.length === 0
                ? ""
                : selectedCustomer[0].pantData?.length !== 0
                    ? selectedCustomer[0].pantData?.height || ""
                    : "",
        kambar:
            selectedCustomer.length === 0
                ? ""
                : selectedCustomer[0].pantData?.length !== 0
                    ? selectedCustomer[0].pantData?.kambar || ""
                    : "",
        mandi:
            selectedCustomer.length === 0
                ? ""
                : selectedCustomer[0].pantData?.length !== 0
                    ? selectedCustomer[0].pantData?.mandi || ""
                    : "",
        bottom:
            selectedCustomer.length === 0
                ? ""
                : selectedCustomer[0].pantData?.length !== 0
                    ? selectedCustomer[0].pantData?.bottom || ""
                    : "",
    };

    const handleSubmit = async (values) => {
        try {
            setIsSubmitting(true);
            if (categoryId === "") {
                setIsSubmitting(false);
                return Notification("", "पँन्ट चे प्रकार निवडा", "error");
            }
            if (optionIds.length === 0) {
                setIsSubmitting(false);
                return Notification("", "पँन्ट चे ऑपशन निवडा", "error");
            }

            const { address, customername, phonenumber, ...rest } = values;
            let pantSizeData = {
                ...rest,
                id: rest.pantSizeId,
            };
            let customerData = {
                name: customername,
                address,
                phonenumber,
            };
            let customerId =
                selectedCustomer.length !== 0
                    ? selectedCustomer[0].id || selectedCustomer[0].value
                    : undefined;

            // This is for update customer or add new customer
            if (customerStatus === "2") {
                customerId = await dispatch(addCustomer(customerData));
            }
            if (customerStatus === "1") {
                if (!customerId) {
                    setIsSubmitting(false);
                    return Notification("", " कस्टमर सिलेक्ट करा.", "error");
                }
                if (
                    customerData.name !== defaultValues.customername ||
                    customerData.address !== defaultValues.address ||
                    customerData.phonenumber !== defaultValues.phonenumber
                ) {
                    await dispatch(updateCustomer(customerId, customerData));
                }
            }
            pantSizeData = {
                ...pantSizeData,
                customer: customerId,
            };
            // This is for update pantsize or add new pantsize
            let newPantSize = "";
            if (pantSizeData.id === "") {
                newPantSize = await dispatch(addPant(pantSizeData));
                pantSizeData = {
                    ...pantSizeData,
                    id: newPantSize.id,
                };
            } else {
                if (
                    pantSizeData.seat !== defaultValues.seat ||
                    pantSizeData.gudga !== defaultValues.gudga ||
                    pantSizeData.height !== defaultValues.height ||
                    pantSizeData.mandi !== defaultValues.mandi ||
                    pantSizeData.kambar !== defaultValues.kambar ||
                    pantSizeData.bottom !== defaultValues.bottom
                ) {
                    await dispatch(updatePant(pantSizeData.id, pantSizeData));
                }
            }
            let pantoptions = optionIds.map((data) => data.value);
            let orderData = {
                pantcategory: categoryId.value,
                pantoptions: pantoptions,
                customer: customerId,
            };
            await dispatch(updatePantOrder(order.id, orderData));
            setIsSubmitting(false);
        } catch (err) {
            setIsSubmitting(false);
            throw err;
        }
    };
    if (
        loading
    ) {
        return (
            <Flex h="100vh" w="100vw" justify="center" align="center">
                <Spinner />
            </Flex>
        );
    }
    return (
        <BasicLayout>
            <Flex minH="80vh" w="100%" justify="center">
                <Flex h="100%" w="100%" pt={10} pb={10} pr="2" pl="2">
                    <Formik
                        enableReinitialize
                        initialValues={defaultValues}
                        onSubmit={handleSubmit}
                    >
                        {(props) => (
                            <Form>
                                <Flex justify="space-between" w="95vw" margin="auto">
                                    <Box w="25%">
                                        <Heading as="h5" fontSize="28px">
                                            पँन्ट चे प्रकार
                                        </Heading>
                                        <Select
                                            value={categoryId}
                                            isSearchable
                                            placeholder="प्रकार"
                                            options={pantcategories?.map((item) => ({
                                                label: item.category,
                                                value: item.id,
                                            }))}
                                            onChange={(e) =>
                                                setCategoryId({ label: e.label, value: e.value })
                                            }
                                        />
                                    </Box>

                                    <Box w="30%">
                                        <Heading as="h5" fontSize="28px">
                                            पँन्ट चे ऑपशन
                                        </Heading>
                                        <Select
                                            value={optionIds}
                                            isSearchable
                                            isMulti
                                            closeMenuOnSelect={false}
                                            placeholder="ऑपशन"
                                            name="optionIds"
                                            options={pantoptions?.map((item) => ({
                                                label: item.option,
                                                value: item.id,
                                            }))}
                                            onChange={(e) => {
                                                setOptionIds(e);
                                            }}
                                        />
                                    </Box>
                                    <Box w="30%">
                                        <RadioGroup
                                            onChange={setCustomerStatus}
                                            value={customerStatus}
                                            mt="5"
                                            mb="5"
                                        >
                                            <Stack direction="row">
                                                <Radio value="1">जुने</Radio>
                                                <Radio value="2">नवीन</Radio>
                                            </Stack>
                                        </RadioGroup>
                                        {/* if customer have old customer id */}
                                        {customerStatus === "1" ? (
                                            <Box mt="5" mb="5">
                                                <Select
                                                    defaultValue=""
                                                    isSearchable
                                                    placeholder="शोधा"
                                                    name="customerId"
                                                    options={customers?.map((item) => ({
                                                        label: item.name,
                                                        name: item.name,
                                                        value: item.id,
                                                        address: item.address,
                                                        phonenumber: item.phonenumber,
                                                        pantData: item.pant,
                                                    }))}
                                                    onChange={(e) => setSelectedCustomer([e])}
                                                />
                                            </Box>
                                        ) : null}
                                        <CustomerRegisterForm
                                            customername="customername"
                                            phonenumber="phonenumber"
                                            address="address"
                                        />
                                        <Box mt={5}>
                                            <PantSizeForm
                                                bottom="bottom"
                                                height="height"
                                                gudga="gudga"
                                                mandi="mandi"
                                                kambar="kambar"
                                                seat="seat"
                                            />
                                        </Box>
                                        <Button
                                            type="submit"
                                            colorScheme="facebook"
                                            fontSize="20px"
                                            mt={5}
                                            isLoading={isSubmitting}
                                        >
                                            अपडेट करा
                                        </Button>
                                    </Box>
                                </Flex>
                            </Form>
                        )}
                    </Formik>
                </Flex>
            </Flex>
        </BasicLayout>
    );
};

export default Index;
